<a
  href="javascript:void(0)"
  (click)="updateIndex()"
  [className]="'peak-bar peak-bar--' + content.stacks[index].tier"
  role="button"
>
  <div
    [className]="
      'peak-bar__triangle peak-bar__triangle--' + content.stacks[index].tier
    "
  >
    <span class="sr-only">
      {{ content.stacks[index].ariaLabels.peekBar }}
    </span>
  </div>
</a>
